import { getProposedOptions } from './StoreProposedOptions';
/**
 * @function hasProposedOptionsInSelection
 * @since 1.0.0
 */
export function hasProposedOptionsInSelection(selectedItems, saleItems) {
    return selectedItems.some((selectedItem) => {
        const saleItem = saleItems.find((entry) => entry.id === selectedItem.id);
        return saleItem != null && getProposedOptions(saleItem).length > 0;
    });
}
/**
 * A product asks VOUCHER fields: the customer fills them, once per voucher,
 * in the "details" step.
 * @function hasVoucherFieldsInSelection
 * @since 1.0.0
 */
export function hasVoucherFieldsInSelection(selectedItems, saleItems) {
    return selectedItems.some((selectedItem) => {
        var _a, _b;
        const saleItem = saleItems.find((entry) => entry.id === selectedItem.id);
        return ((_b = (_a = saleItem === null || saleItem === void 0 ? void 0 : saleItem.voucherFieldGroups) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0;
    });
}
/**
 * @function getStepSequence
 * @since 1.0.0
 */
function getStepSequence(hasOptionsStep, hasDetailsStep) {
    return [
        'products',
        ...(hasOptionsStep ? ['options'] : []),
        ...(hasDetailsStep ? ['details'] : []),
        'contact',
        'payment'
    ];
}
/**
 * @function buildStoreSteps
 * @since 1.0.0
 */
export function buildStoreSteps(hasOptionsStep, paymentLabel, hasDetailsStep = false) {
    const labels = {
        products: t('Selection'),
        options: t('Options'),
        details: t('Information'),
        contact: t('Order'),
        payment: paymentLabel
    };
    return getStepSequence(hasOptionsStep, hasDetailsStep).map((id) => ({
        id,
        label: labels[id]
    }));
}
/**
 * @function getStepIndex
 * @since 1.0.0
 */
export function getStepIndex(stepId, hasOptionsStep, paymentLabel, hasDetailsStep = false) {
    return buildStoreSteps(hasOptionsStep, paymentLabel, hasDetailsStep).findIndex((step) => step.id === stepId);
}
/**
 * @function getNextStepId
 * @since 1.0.0
 */
export function getNextStepId(current, hasOptionsStep, hasDetailsStep = false) {
    const sequence = getStepSequence(hasOptionsStep, hasDetailsStep);
    const index = sequence.indexOf(current);
    if (index === -1 || index >= sequence.length - 1) {
        return null;
    }
    return sequence[index + 1];
}
/**
 * @function getPrevStepId
 * @since 1.0.0
 */
export function getPrevStepId(current, hasOptionsStep, hasDetailsStep = false) {
    const sequence = getStepSequence(hasOptionsStep, hasDetailsStep);
    const index = sequence.indexOf(current);
    if (index <= 0) {
        return null;
    }
    return sequence[index - 1];
}
